//
// # TextEntity
//

// Workspace Imports
import { graphics, Bbox, Point } from "GenAlphaModel";
// Local Imports
import { EntityKind } from "../entity";
import type { MousePos } from "../mousepos";
import type { DrawTo } from "../draw";
import type { Table, TextStyle } from "../style";
import { Entity, type Parent } from "../tree";
import { Cache } from "../style";

export class TextEntity extends Entity<graphics.Text> {
  readonly entityKind = EntityKind.Text;
  override readonly cache: Cache<TextStyle>;

  constructor(arg: {
    data: graphics.Text;
    parent: Parent;
    table: Table<TextStyle>;
  }) {
    super(arg);
    this.cache = new Cache(arg.table, this);
  }

  override redraw = (to: DrawTo): unknown => {
    return to.text(this.data, this.cache.style, this.parent);
  };

  // Current location of the text element.
  get loc(): Point {
    return this.data.loc;
  }

  // Translate the text to a new location.
  updateLoc = (loc: Point): unknown => {
    return this.update({ loc });
  };

  // Hit test against the text bounding box.
  hitTest = (mousePos: MousePos): boolean => {
    const bbox = graphics.Text.bbox(this.data);
    return Bbox.contains(bbox, mousePos.sch);
  };
}
